import ApiHelper from "../../../shared/ApiHelper";
import Settings from "../../../constants/Settings";
import { IUserListServiceObj } from "../../../shared/apiServices/IApiInterfaces";

const ManageUsersApiHelpers = {
    getAllUsers: async (): Promise<IUserListServiceObj> => {
        return (await ApiHelper.get(`${Settings.HabitatUrl}/users`, true)).data;
    },
    deleteUser: async (userId: string): Promise<any> => {
        return (await ApiHelper.delete(`${Settings.HabitatUrl}/users/${userId}`, true)).data;
    },
    updateUser: async (userName: string, isAdmin: boolean): Promise<any> => {
        return (await ApiHelper.put(`${Settings.HabitatUrl}/users/${userName}/adminuser/${isAdmin}`, true, {})).data;
    }
}

export default ManageUsersApiHelpers;
